import TargetZoneCard from "./TargetZoneCard";
export default TargetZoneCard;
